import { httpGet } from "./AbstractService";
import ENDPOINTS from "../data/endpoints.json";

export function getAnnouncements(school, jwt) {
    return httpGet( jwt, `${ENDPOINTS[school.region].school}/school/announcement`);
}
